/**
 * Applies the palette of the previous v0 `better-tracking.map` to its v2
 * Standard counterparts.
 */
const PAINT_OVERRIDES = [
  [
    ['land'],
    'background-color',
    [
      'interpolate',
      ['linear'],
      ['zoom'],
      0,
      '#f0f1f0',
      8,
      '#eff0ec',
      14,
      '#edeee8',
      15,
      '#eeefe9',
      17,
      '#f1f2ec'
    ]
  ],
  [['landuse_desert', 'landuse_glacier'], 'fill-color', '#e1e3d0'],
  [['landuse_urban'], 'fill-color', '#d9d1ba'],
  [['landuse_urban'], 'fill-opacity', 0.2],
  [
    ['landuse_misc', 'landuse_public-complex', 'landuse_public-complex-above'],
    'fill-color',
    '#eeefe8'
  ],
  [['landuse_greenspace'], 'fill-color', '#599507'],
  [['landuse_greenspace'], 'fill-opacity', 0.12],
  [['landuse_beach'], 'fill-color', '#f5ebd4'],
  [['landuse_aerodrome', 'landuse_runway'], 'fill-color', '#e3e0d3'],
  [['landuse_reservation'], 'fill-color', '#e1e3d0'],
  [
    ['water_fill', 'water_ocean', 'water_pier-polygon'],
    'fill-color',
    '#b8e6ff'
  ],
  [
    ['water_fill', 'water_ocean', 'water_pier-polygon'],
    'fill-outline-color',
    '#b8e6ff'
  ],
  [['water_waterway'], 'line-color', '#8ccfd9'],
  [['water_pier-line'], 'line-color', '#8ccfd9'],
  [['ferry_line'], 'line-color', '#f7fdff'],
  [['ferry_line'], 'line-opacity', 0.8],
  [
    [
      'admin_region',
      'admin_country',
      'admin_region-disputed-mask',
      'admin_region-disputed',
      'admin_country-disputed-mask',
      'admin_country-disputed'
    ],
    'line-color',
    '#9c9c9c'
  ],
  [['building_fill', 'building_fill-above-tunnel'], 'fill-color', '#e5e5dd'],
  [['building_line'], 'line-color', '#d9d9d1'],
  [['airport_runway-casing'], 'line-color', '#d9d9d1'],
  [['airport_runway'], 'line-color', '#e3e0d3'],
  [
    [
      'tunnel_service-casing',
      'tunnel_minor-casing',
      'tunnel_tertiary-link-casing',
      'tunnel_primary-link-casing',
      'tunnel_motorway-trunk-link-casing',
      'tunnel_tertiary-casing',
      'tunnel_primary-casing',
      'tunnel_motorway-trunk-casing',
      'road_service-casing',
      'road_minor-casing',
      'road_tertiary-link-casing',
      'road_primary-link-casing',
      'road_motorway-trunk-link-casing',
      'road_tertiary-casing',
      'road_primary-casing',
      'road_motorway-trunk-casing',
      'bridge_service-casing',
      'bridge_minor-casing',
      'bridge_tertiary-link-casing',
      'bridge_primary-link-casing',
      'bridge_motorway-trunk-link-casing',
      'bridge_tertiary-casing',
      'bridge_primary-casing',
      'bridge_motorway-trunk-casing'
    ],
    'line-color',
    '#ffffff'
  ],
  [
    [
      'tunnel_service',
      'tunnel_minor',
      'tunnel_tertiary-link',
      'tunnel_tertiary',
      'road_service',
      'road_minor',
      'road_tertiary-link',
      'road_tertiary',
      'road_path',
      'bridge_service',
      'bridge_minor',
      'bridge_tertiary-link',
      'bridge_tertiary',
      'bridge_path-under',
      'bridge_path'
    ],
    'line-color',
    '#ffffff'
  ],
  [
    [
      'tunnel_primary-link',
      'tunnel_primary',
      'road_primary',
      'road_primary-link',
      'bridge_primary-link',
      'bridge_primary'
    ],
    'line-color',
    '#dbdbdb'
  ],
  [
    [
      'tunnel_motorway-trunk-link',
      'tunnel_motorway-trunk',
      'road_motorway-trunk',
      'road_motorway-trunk-link',
      'bridge_motorway-trunk-link',
      'bridge_motorway-trunk'
    ],
    'line-color',
    '#dbdbdb'
  ],
  [['rail_road', 'rail_bridge'], 'line-color', '#d4cfc6'],
  [
    ['rail_tunnel', 'rail_tie_tunnel', 'rail_tie', 'rail_tie_bridge'],
    'line-color',
    '#e6e6e3'
  ],
  [['water_label-point', 'water_label-line'], 'text-color', '#3f88a7'],
  [['water_label-point', 'water_label-line'], 'text-halo-color', '#ffffff'],
  [['water_label-point', 'water_label-line'], 'text-halo-width', 1],
  [['ferry_label'], 'text-color', '#34707e'],
  [['ferry_label'], 'text-halo-color', '#ffffff'],
  [['ferry_label'], 'text-halo-width', 1.2],
  [
    [
      'poi_landuse_park_lowzoom',
      'poi_landuse_park',
      'nationalpark_label_lowzoom',
      'nationalpark_label'
    ],
    'text-color',
    '#2e8008'
  ],
  [
    [
      'poi_landuse_park_lowzoom',
      'poi_landuse_park',
      'nationalpark_label_lowzoom',
      'nationalpark_label'
    ],
    'text-halo-color',
    '#ffffff'
  ],
  [
    [
      'poi_landuse_park_lowzoom',
      'poi_landuse_park',
      'nationalpark_label_lowzoom',
      'nationalpark_label'
    ],
    'text-halo-width',
    1.5
  ],
  [['poi_landuse_public_complex'], 'text-color', '#404040'],
  [['poi_landuse_public_complex'], 'text-halo-color', '#ffffff'],
  [['poi_landuse_public_complex'], 'text-halo-width', 1],
  [
    [
      'building_label_number',
      'poi_800_facilities_generic',
      'poi_800_facilities',
      'poi_900_areas_buildings'
    ],
    'text-color',
    '#262317'
  ],
  [
    [
      'building_label_number',
      'poi_800_facilities_generic',
      'poi_800_facilities',
      'poi_900_areas_buildings'
    ],
    'text-halo-color',
    '#ffffff'
  ],
  [
    [
      'building_label_number',
      'poi_800_facilities_generic',
      'poi_800_facilities',
      'poi_900_areas_buildings'
    ],
    'text-halo-width',
    1
  ],
  [['road_label_service', 'road_label_small'], 'text-color', '#595959'],
  [['road_label_medium', 'road_label_large'], 'text-color', '#4e4e4e'],
  [
    [
      'road_label_service',
      'road_label_small',
      'road_label_medium',
      'road_label_large'
    ],
    'text-halo-color',
    '#ffffff'
  ],
  [
    [
      'road_label_service',
      'road_label_small',
      'road_label_medium',
      'road_label_large'
    ],
    'text-halo-width',
    1
  ],
  [['admin_label_region'], 'text-color', '#4d324d'],
  [['admin_label_region'], 'text-halo-color', '#ffffff'],
  [['admin_label_region'], 'text-halo-width', 1.5],
  [['airport_label'], 'text-color', '#686868'],
  [['airport_label'], 'text-halo-color', '#ffffff'],
  [['airport_label'], 'text-halo-width', 1],
  [
    [
      'place_label_locality_settlement_small',
      'place_label_locality_settlement',
      'place_label_locality_city',
      'admin_label_country'
    ],
    'text-color',
    '#000000'
  ],
  [
    [
      'place_label_locality_settlement_small',
      'place_label_locality_settlement',
      'place_label_locality_city',
      'admin_label_country'
    ],
    'text-halo-color',
    '#ffffff'
  ],
  [
    [
      'place_label_locality_settlement_small',
      'place_label_locality_settlement',
      'place_label_locality_city',
      'admin_label_country'
    ],
    'text-halo-width',
    1
  ],
  [['admin_label_continent'], 'text-color', '#363636'],
  [['admin_label_continent'], 'text-halo-color', '#ffffff'],
  [['admin_label_continent'], 'text-halo-width', 2]
];

const HIDDEN_POI_LAYERS = [
  'poi_100_food_drink',
  'poi_200_going_out_entertainment',
  'poi_300_sights_museums',
  'poi_400_transit_small',
  'poi_400_transit',
  'poi_500_accommodations',
  'poi_550_leisure_outdoor',
  'poi_600_shopping',
  'poi_700_business_services_generic',
  'poi_700_business_services',
  'poi_800_facilities_generic',
  'poi_800_facilities',
  'poi_900_areas_buildings'
];

export const applyMapTheme = map => {
  if (!map?.getLayer || !map?.setPaintProperty) return;

  PAINT_OVERRIDES.forEach(([layerIds, property, value]) => {
    layerIds.forEach(layerId => {
      if (map.getLayer(layerId)) {
        map.setPaintProperty(layerId, property, value);
      }
    });
  });

  if (!map.setLayoutProperty) return;

  HIDDEN_POI_LAYERS.forEach(layerId => {
    if (map.getLayer(layerId)) {
      map.setLayoutProperty(layerId, 'visibility', 'none');
    }
  });
};
